import _classCallCheck from "/var/www/vhosts/jidlopodnos.cz/nove.jidlopodnos.cz/frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/var/www/vhosts/jidlopodnos.cz/nove.jidlopodnos.cz/frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/var/www/vhosts/jidlopodnos.cz/nove.jidlopodnos.cz/frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "/var/www/vhosts/jidlopodnos.cz/nove.jidlopodnos.cz/frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createSuper";
import { WebPlugin } from '@capacitor/core';
export var AppTrackingTransparencyWeb = /*#__PURE__*/function (_WebPlugin) {
  _inherits(AppTrackingTransparencyWeb, _WebPlugin);

  var _super = _createSuper(AppTrackingTransparencyWeb);

  function AppTrackingTransparencyWeb() {
    _classCallCheck(this, AppTrackingTransparencyWeb);

    return _super.apply(this, arguments);
  }

  _createClass(AppTrackingTransparencyWeb, [{
    key: "getStatus",
    value: function getStatus() {
      return Promise.resolve({
        status: 'authorized'
      });
    }
  }, {
    key: "requestPermission",
    value: function requestPermission() {
      return Promise.resolve({
        status: 'authorized'
      });
    }
  }]);

  return AppTrackingTransparencyWeb;
}(WebPlugin);